import { Margin } from 'recharts/types/util/types';

export const LABEL_HEIGHT = 38;
export const LABEL_PADDING = 8;

export const SANKEY_NODE_WIDTH = 10;
export const SANKEY_CHART_HEIGHT = 200;
export const SANKEY_NODE_RADIUS = 4;

export const SANKEY_MARGIN: Margin = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
};

// Minimum non-zero value used when an underlying data value is 0.
// Some Sankey rendering logic treats 0 as "no link", so this guard
// ensures that links/nodes still render with a visible thickness.
export const MIN_SANKEY_VALUE = 1;

// Default values used when all underlying data values are 0 or missing.
// These numbers are chosen to keep the same relative proportions:
// total (10) split into multi-unit (8) and loyalty (2).
// This maintains a consistent-looking Sankey while clearly being placeholder data.
export const DEFAULT_TOTAL_VALUE = 10;
export const DEFAULT_MULTI_UNIT_VALUE = 8;
export const DEFAULT_LOYALTY_VALUE = 2;
